export class SignInTypes {
    public static usernameAndPassword = 'USERNAMEPASSWORD';
    public static certificate = 'CERTIFICATE';
    public static impersonation = 'IMPERSONATION';
}
